<div class="confirm-dialog">
  <button mat-icon-button class="dialog-close" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog-icon" [ngClass]="data.iconClass || 'icon-danger'">
    <mat-icon>{{ data.icon || 'error_outline' }}</mat-icon>
  </div>

  <h2 class="dialog-title">{{ data.title }}</h2>

  <div class="dialog-message">
    <p>{{ data.message }}</p>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button class="cancel-btn" [mat-dialog-close]="false">
      {{ data.cancelButtonText || 'Cancel' }}
    </button>
    <button mat-raised-button class="confirm-btn btn-blue" [mat-dialog-close]="true">
      {{ data.confirmButtonText || 'OK' }}
    </button>
  </div>
</div>
